import { Theme } from "@emotion/react";
import { Box, Grid, SxProps, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { IWelcomeItem } from "../../models/IWelcomeItem";
import Item from "../commons/Item";
import Text from "../commons/Text";

interface IWelcomeSectionProps {
    title: string;
    label?: string;
    link?: string;
    items?: IWelcomeItem[];
}

const titleContainerSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  marginBottom: '16px',
};

const titleSx: SxProps<Theme> = {
  fontFamily: 'AllertaStencil',
  fontSize: 32,
};

const labelSx: SxProps<Theme> = {
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
}

const WelcomeSection = (props: IWelcomeSectionProps) => {

    const {title, label, link, items} = props;
    const navigate = useNavigate();

    return (
        <Box sx={{marginTop: "32px", marginBottom: "64px"}}>

            <Box sx={titleContainerSx}>
                <Typography variant="h2" gutterBottom sx={titleSx}>
                    {title}
                </Typography>

                {link && (
                    <Box sx={labelSx} onClick={() => navigate(link ?? '')}>
                        <Text text={`Voir les ${items?.length} ${label} >`} fontSize={20}/>
                    </Box>
                )}
            </Box>
            
            <Grid container spacing={4}>
                {items?.slice(0,6).map(item =>
                    <Grid item key={item.id} xs={6} md={3} lg={2} xl={2}>
                        <Item label={item.title} image={item.image} link={item.link}/>
                    </Grid>)
                }
            </Grid>
        </Box>
    );
}

export default WelcomeSection;